// extracted by mini-css-extract-plugin
module.exports = {"container":"StaffmemberCard_container___Mf_0","image":"StaffmemberCard_image__5PCto","title":"StaffmemberCard_title__PLEeb","copyContainer":"StaffmemberCard_copyContainer__2LiaJ"};